import React from 'react';

const MoreFilters = ({
  width = '16px',
  height = '16px',
  fill = 'currentColor',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 4.66663L14 4.66663"
      stroke="#13142A"
      strokeWidth="1.33475"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33337 11.3334L2.00004 11.3334"
      stroke="#13142A"
      strokeWidth="1.33475"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="4.00004"
      cy="4.66667"
      r="1.99929"
      stroke="#13142A"
      strokeWidth="1.33475"
    />
    <path
      d="M10.0007 11.3333C10.0007 10.2292 10.8958 9.33404 12 9.33404C13.1041 9.33404 13.9993 10.2292 13.9993 11.3333C13.9993 12.4375 13.1041 13.3326 12 13.3326C10.8958 13.3326 10.0007 12.4375 10.0007 11.3333Z"
      stroke="#13142A"
      strokeWidth="1.33475"
    />
  </svg>
);

export default MoreFilters;
